// Templates de mensagem para cada tipo de convite (link ou código)
const messageTemplates = {
  
  whatsapp: {
    // Mensagem para convite via link no WhatsApp
    link: (url) =>
      `Olá! Você foi convidado a se vincular à minha conta na plataforma Afinando o Cérebro.\n` +
      `Clique no link para entrar com sua conta ou criar uma nova, caso ainda não tenha:\n${url}`,

    // Mensagem para convite via código no WhatsApp
    code: (code) =>
      `Olá! Você recebeu um código de convite para se vincular à minha conta na plataforma Afinando o Cérebro.\n` +
      `Código de convite: *${code}*\n` +
      `Para utilizá-lo, entre na sua conta, vá até o Menu e clique em "Resgatar código convite". Assim que o código for resgatado, sua conta estará vinculada.`,
  },
  email: {
    // Mensagem para convite via link por email
    link: (url) =>
      `Olá,\n\n` +
      `Você foi convidado a se vincular à minha conta na plataforma Afinando o Cérebro, onde usamos jogos e atividades para estimular habilidades auditivas cognitivas de forma divertida e eficaz.\n\n` +
      `Para acessar e se vincular, clique no link abaixo:\n` +
      `${url}\n\n` +
      `Você poderá entrar com sua conta existente ou criar uma nova, caso ainda não tenha.`,

    // Mensagem para convite via código por email
    code: (code) => `
        Olá,

        Você recebeu um código para se vincular à minha conta na plataforma Afinando o Cérebro.

        Código de convite: ${code}

        Para utilizá-lo, entre na sua conta, vá até o Menu e clique em "Resgatar código convite".

        Assim que o código for resgatado, sua conta estará vinculada. 
      `,
  },
};

// Função para criar e abrir o link do WhatsApp com a mensagem de convite
export const handleWhatsappClick = (value, type) => {
  // Escolhe o template correto da mensagem conforme o tipo (link ou code)
  // Se o tipo não existir, usa a mensagem padrão para código
  const message = messageTemplates.whatsapp[type]
    ? messageTemplates.whatsapp[type](value)
    : messageTemplates.whatsapp.code(value);

  // Cria a URL para abrir o WhatsApp com o texto codificado
  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;

  // Abre o WhatsApp numa nova aba com a mensagem pronta para envio
  window.open(whatsappUrl, "_blank");
};


// Função para criar e abrir o email com o convite já preenchido
export const handleEmailClick = (value, type) => {
  // Escolhe o template correto da mensagem conforme o tipo (link ou code)
  // Se o tipo não existir, usa a mensagem padrão para código
  const message = messageTemplates.email[type]
    ? messageTemplates.email[type](value)
    : messageTemplates.email.code(value);

  // Define o assunto do email conforme o tipo do convite
  const subject =
    type === "link"
      ? "Afinando o Cérebro: convite para acesso"
      : "Afinando o Cérebro: código de convite";

  // Cria a URL mailto com o assunto e corpo da mensagem codificados
  const mailtoUrl = `mailto:?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(message)}`;

  // Abre o cliente de email padrão com o email pronto para envio
  window.open(mailtoUrl, "_blank");
};
